import { ApiUtil } from '@/shared/api';

export const getDataImportApi = {
    /** 자료 불러오기 - 자료 상세정보 조회 */
    getLesnRscInfo: (param: API.LesnRscInfo.Req) => {
        return ApiUtil.get<API.LesnRscInfo.Res>('/tch/lesn-rsc/info', param);
    },

    /** 자료 불러오기 - 출제범위 조회 */
    getLesnRscExamScope: (param: API.LesnRscExamScope.Req) => {
        return ApiUtil.get<API.LesnRscExamScope.Res>('/tch/lesn-rsc/exam-scope', param);
    },
};
